import React from 'react'
import { Button } from 'spa/member/components/v2/Button';
import { InputForm } from 'spa/member/components/InputForm';

export const StyledQuickSignupForm: React.FC = () => {
  return (
    <div>
      <div className="flex flex-row w-full gap-XS pb-L">
        <InputForm name='lastName' label='姓' inputProps={{placeholder: "クラウド" }} />
        <InputForm name='firstName' label='名' inputProps={{placeholder: "太郎" }} />
      </div>
      <div className="flex flex-row w-full gap-XS pb-L">
        <InputForm name='lastNameKana' label='せい' inputProps={{placeholder: "くらうど"}} />
        <InputForm name='firstNameKana' label='めい' inputProps={{placeholder: "たろう"}} />
      </div>
      <div className="pb-L">
        <InputForm name='email' label='メールアドレス' inputProps={{placeholder: "email@example.com"}} />
      </div>
      <div className="flex justify-center w-full py-M">
        <Button kind="danger" className="all:w-full tablet:w-80">無料登録へ</Button>
      </div>
    </div>
  );
}
